/* eslint-disable react/prop-types */
import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride } from "@shared/primitive-components"
import { IFrame } from "./iframe"

export const Customers: React.FC<RouteComponentProps> = () => (
  <>
    <DocumentTitleOverride>Flock Motor | Customers</DocumentTitleOverride>
    <IFrame path="customers" />
  </>
)
